import React, { FC } from 'react';
import TableRow from '@mui/material/TableRow';
import { StyledTableCell } from 'molecules/Table/styles';
import loaderGif from 'assets/images/loaderGif.gif';
import { Stack } from '@mui/material';

const LoadingRow: FC<{ loadingText?: string }> = ({ loadingText }) => (
  <TableRow>
    <StyledTableCell colSpan={20} sx={{ textAlign: 'center' }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={2}
      >
        <img src={loaderGif} alt="Data loading" />
        {loadingText ? <span style={{ opacity: 0.6 }}>{loadingText}</span> : ''}
      </Stack>
    </StyledTableCell>
  </TableRow>
);

export default LoadingRow;
